import { createFileRoute } from '@tanstack/react-router'

import { ExclusionsDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/exclusions-documentation-page.tsx'

export const Route = createFileRoute('/bo/documentation/exclusions')({
  component: () => <ExclusionsDocumentationPage />,
})
